import { memo } from 'react';

import { CustomListDetail } from 'widgets/CustomListDetail';

const CustomListPage = memo(() => <CustomListDetail />);

export default CustomListPage;
